import { createStore } from "vuex";
import { login, Location } from "../API/API";
import httpClient from "@/API/HttpClient";
import router from "../router";
import cart from "@/store/modules/cart";

let locationInterval = null;

export default createStore({
  state: {
    token: localStorage.getItem("token"),
    isLoggIn: Boolean(localStorage.getItem("token")),
    locationError: null,
    gpsStatus: null, // 'on' یا 'off'
    location: null,
  },

  mutations: {
    SET_LOCATION_ERROR(state, message) {
      state.locationError = message;
    },
    CLEAR_LOCATION_ERROR(state) {
      state.locationError = null;
    },
    SET_GPS_STATUS(state, status) {
      state.gpsStatus = status;
    },
    SET_LOCATION(state, coords) {
      state.location = coords;
    },
    SET_TOKEN(state, token) {
      state.isLoggIn = true;
      state.token = token;
      localStorage.setItem("token", token);
    },
    REMOVE_TOKEN(state) {
      state.isLoggIn = false;
      state.token = "";
      localStorage.removeItem("token");
    },
    SAVE_CART(state, _, rootState) {
      localStorage.setItem("cart", JSON.stringify(rootState.cart.products));
    },
  },

  actions: {
    login({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        login(params)
          .then((resp) => {
            if (resp.data.StatusCode == 422) reject(resp.data.Message);

            httpClient.defaults.headers.common["Authorization"] =
              "Bearer " + resp.data.loginResponse.token;

            commit("SET_TOKEN", resp.data.loginResponse.token);

            // شروع خودکار موقعیت‌یابی
            dispatch("startLocationTracker");

            resolve();
          })
          .catch((err) => reject(err));
      });
    },

    logout({ commit, dispatch }) {
      commit("REMOVE_TOKEN");
      dispatch("cart/emptyCart", null, { root: true });
      dispatch("stopLocationTracker");
      router.push("/login?relogin=true");
      localStorage.clear();
    },

    startLocationTracker({ commit }) {
      if (locationInterval) return;

      if (!navigator.geolocation) {
        commit("SET_LOCATION_ERROR", "مرورگر شما از GPS پشتیبانی نمی‌کند.");
        commit("SET_GPS_STATUS", "off");
        return;
      }

      const startTracking = () => {
        const sendLocationToAPI = async (pos) => {
          const coords = {
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
            speed: pos.coords.speed || 0,
            heading: pos.coords.heading || 0,
            timestamp: new Date(pos.timestamp).toISOString(),
          };

          const body = { marketerId: "0", ...coords };

          try {
            const resp = await Location(body);
            console.log(resp);
            commit("SET_LOCATION", coords);
            commit("SET_GPS_STATUS", "on");
            commit("CLEAR_LOCATION_ERROR");
          } catch (err) {
            commit(
              "SET_LOCATION_ERROR",
              "خطا در ارسال موقعیت. لطفا اتصال اینترنت و GPS را بررسی کنید."
            );
          }
        };

        const handleLocationError = (err) => {
          commit("SET_GPS_STATUS", "off");
          switch (err.code) {
            case err.PERMISSION_DENIED:
              commit(
                "SET_LOCATION_ERROR",
                "برای استفاده از سرویس، GPS دستگاه شما باید روشن و دسترسی داده شود."
              );
              break;
            case err.POSITION_UNAVAILABLE:
              commit(
                "SET_LOCATION_ERROR",
                "موقعیت شما در دسترس نیست. لطفا GPS را بررسی کنید."
              );
              break;
            case err.TIMEOUT:
              commit(
                "SET_LOCATION_ERROR",
                "درخواست دریافت موقعیت به پایان رسید. دوباره تلاش کنید."
              );
              break;
            default:
              commit(
                "SET_LOCATION_ERROR",
                "خطای ناشناخته در دریافت موقعیت رخ داد."
              );
          }
        };

        // گرفتن اولین موقعیت
        navigator.geolocation.getCurrentPosition(
          sendLocationToAPI,
          handleLocationError
        );

        // ادامه با interval هر ۳ دقیقه
        locationInterval = setInterval(() => {
          navigator.geolocation.getCurrentPosition(
            sendLocationToAPI,
            handleLocationError
          );
        }, 3 * 60 * 1000);
      };

      // بررسی دسترسی به GPS
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((result) => {
            if (result.state === "denied") {
              commit(
                "SET_LOCATION_ERROR",
                "لطفا دسترسی GPS را به سایت بدهید تا موقعیت شما ثبت شود."
              );
              commit("SET_GPS_STATUS", "off");
            } else {
              startTracking();
            }
          })
          .catch(() => startTracking());
      } else {
        startTracking();
      }
    },

    stopLocationTracker() {
      if (locationInterval) {
        clearInterval(locationInterval);
        locationInterval = null;
      }
    },
  },

  modules: { cart },

  getters: {
    isLoggedIn: (state) => Boolean(state.token) && state.token !== "null",
    token: (state) => "Bearer " + state.token,
  },
});
